export const create_exchange_order = `mutation create_exchange_order($input: CreateExchangeOrder!){
    create_exchange_order(input: $input)
}`;
